import { render } from "./TeaserHome.vue?vue&type=template&id=37792b44"
const script = {}

import "./TeaserHome.vue?vue&type=style&index=0&id=37792b44&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__